module.exports = __webpack_public_path__ + "gl.svg?1495643c89bb2002c8d1af03cd3d68b7";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/gl.svg
// module id = 1121
// module chunks = 0